import { useAppQuery } from 'src/core/api';
import { theme } from 'src/core/styles';

import { ThemeProvider, createTheme } from '@mui/material';

export interface AppThemeProviderProps {
  children?: React.ReactNode;
}

export const AppThemeProvider = (props: AppThemeProviderProps) => {
  const { children } = props;

  const { data } = useAppQuery();

  if (!data) {
    return null;
  }

  const newTheme = createTheme({
    ...theme,
    palette: {
      mode: data.color_palette.background === '#FFFFFF' ? 'light' : 'dark',
      background: {
        default: data.color_palette.background,
      },
      primary: {
        main: data.color_palette.primary,
      },
    },
  });

  return <ThemeProvider theme={newTheme}>{children}</ThemeProvider>;
};
